import { get, put, post } from '../utils/request';

// 获取所有校区的公章配置
export async function getAllCampusSealConfigs(): Promise<any[]> {
  return get<any[]>('/admin/campus-seal');
}

// 获取指定校区的公章配置
export async function getCampusSealConfig(campusId: string): Promise<{ sealText: string; sealImagePath: string }> {
  return get<{ sealText: string; sealImagePath: string }>(`/admin/campus-seal/${campusId}`);
}

// 更新校区公章配置
export async function updateCampusSealConfig(
  campusId: string,
  data: { sealText: string; sealImagePath: string }
): Promise<void> {
  return put(`/admin/campus-seal/${campusId}`, data);
}

// 上传校区公章图片
export async function uploadCampusSealImage(file: File): Promise<{ url: string }> {
  const formData = new FormData();
  formData.append('file', file);
  
  return post<{ url: string }>('/admin/upload/seal', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// 获取所有校区的报告自定义配置
export async function getAllCampusReportConfigs(): Promise<any[]> {
  return get<any[]>('/admin/campus-report-config');
}

// 更新校区报告自定义配置
export async function updateCampusReportConfig(
  campusId: string,
  data: {
    badgeImagePath?: string;
    schoolNameImagePath?: string;
    contactEmail?: string;
    contactAddress?: string;
    contactPhone?: string;
    signatureImagePath?: string;
    sealText?: string;
    sealImagePath?: string;
  }
): Promise<void> {
  return put(`/admin/campus-report-config/${campusId}`, data);
}

// 上传校区通用图片（校徽/校名/签名等）
export async function uploadCampusImage(file: File, type: string): Promise<{ url: string }> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  return post<{ url: string }>('/admin/upload/campus-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

// 预览成绩验证报告
export async function previewReport(studentId: string): Promise<string> {
  // 返回 HTML，直接打开新窗口
  return `/api/reports/preview?studentId=${studentId}`;
}
